<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M43.44 19.33L25.25 4.59a2 2 0 00-2.49 0L4.57 18.82a1.5 1.5 0 001.86 2.36l.57-.45V42a2 2 0 002 2h30a2 2 0 002-2V21.21l.56.46a1.5 1.5 0 001.88-2.34zM38 41H10V18.5v-.11l14-11 14 11.39z"/><path d="M17 22a7 7 0 107-7 7 7 0 00-7 7zm7-4a4 4 0 11-4 4 4 4 0 014-4z"/><path d="M29.31 28.63a8.47 8.47 0 01-10.62 0 1.51 1.51 0 00-1.46-.24L14 29.59A1.5 1.5 0 0013 31v5.5a1.5 1.5 0 003 0v-4.45l1.51-.56a11.48 11.48 0 0013 0l1.51.56v4.45a1.5 1.5 0 003 0V31a1.5 1.5 0 00-1-1.41l-3.25-1.2a1.51 1.51 0 00-1.46.24z"/></svg>